import { defineMessages } from '@cookbook/solid-intl'

export const messages = {
    titleMessage: defineMessages({
        defaultMessage: 'Stay in the Loop | Lodgr',
        id: 'StayInTheLoopPageRouting.titleMessage',
    }),
}
